/*
  To send data from server to JS, php inserts them into html page.
  Then JS scraps them from page.
*/

import { htmlIded } from './fun-js-lib/html'

export const isOnMainLogPage = () =>
  htmlIded('print-construction-log') !== null

/** 
 * If pageNumberEl is undefined, element with pageNumber is not found. 
 * It means that this is not daily log page.
 */
export const isOnDailyPage = () =>
  pageIdElement() !== null

/** 
 * There must be `launch-sign-popup` button on editable daily page
 */
export const isOnEditableDailyPage = () =>
  document.getElementsByClassName('launch-sign-popup').length !== 0 ||
  isMeasurementBookEditUrl()

export function isMeasurementBookEditUrl() {
    const urlPath = window.location.pathname; // Get the current URL path
    const pattern = /^\/?measurement-book-pages\/\d+\/edit\/?$/;
    return pattern.test(urlPath);
}

export const pageId = () =>
  pageIdElement().innerHTML

export const pageIdElement = () =>
  document.getElementById('pageIdForJsPDF')

export const logId = () =>
  document.getElementById('logIdForJsPDF').innerHTML